import { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/macro";
import { GoodOnYouPillarNames } from "src/types/Algolia";

export const goodOnYouPillarNamesTranslation: Record<
  GoodOnYouPillarNames,
  MessageDescriptor
> = {
  animals: msg`animals`,
  overall: msg`overall`,
  people: msg`people`,
  planet: msg`planet`,
};
